/* RAYZ full-screen menu: open/close, focus trap, pauses Lenis while open. */
(function () {
  const html = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const menu = () => document.getElementById('RayzMenu');
  let last = null;

  function setExpanded(v) { document.querySelectorAll('[data-rz-menu-open]').forEach((b) => b.setAttribute('aria-expanded', String(v))); }
  function open() {
    const m = menu(); if (!m) return;
    last = document.activeElement;
    m.inert = false;
    html.classList.add('rz-menu-open');
    setExpanded(true);
    const l = window.RayzScroll && RayzScroll.lenis; if (l) l.stop();
    const film = m.querySelector('[data-rz-menu-film]');
    if (film && !reduce) { film.preload = 'auto'; film.play().catch(() => {}); }
    setTimeout(() => { const c = m.querySelector('[data-rz-menu-close]'); if (c) c.focus({ preventScroll: true }); }, 80);
  }
  function close() {
    const m = menu(); if (!m || !html.classList.contains('rz-menu-open')) return;
    html.classList.remove('rz-menu-open');
    m.inert = true;
    setExpanded(false);
    const l = window.RayzScroll && RayzScroll.lenis; if (l) l.start();
    const film = m.querySelector('[data-rz-menu-film]'); if (film) film.pause();
    if (last && last.focus) last.focus({ preventScroll: true });
  }
  window.RayzMenu = { open, close };

  const init = () => { const m = menu(); if (m && !html.classList.contains('rz-menu-open')) m.inert = true; };
  init();
  document.addEventListener('shopify:section:load', init);

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-rz-menu-open]')) { e.preventDefault(); open(); return; }
    const c = e.target.closest('[data-rz-menu-close]');
    if (c) { if (c.tagName !== 'A') e.preventDefault(); close(); return; }
    if (e.target.closest('#RayzMenu a[href]')) close();
  });
  document.addEventListener('keydown', (e) => {
    if (!html.classList.contains('rz-menu-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    const f = [...menu().querySelectorAll('a[href], button:not([disabled])')].filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], lastEl = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
    else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
  });
})();

/* Shop dropdown: opens on hover (with a little intent delay), on focus and on tap; closes on leave or Escape. */
(function () {
  const html = document.documentElement;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  let openT, closeT;
  const panel = () => document.querySelector('[data-rz-mega-panel]');
  const btn = () => document.querySelector('.rz-shop-btn');
  function open() {
    clearTimeout(closeT);
    if (!panel() || html.classList.contains('rz-mega-open')) return;
    html.classList.add('rz-mega-open');
    btn().setAttribute('aria-expanded', 'true');
    const hdr = document.querySelector('.rz-header-section'); if (hdr) hdr.classList.remove('is-tucked');
  }
  function close(now) {
    clearTimeout(openT);
    const go = () => { html.classList.remove('rz-mega-open'); const b = btn(); if (b) b.setAttribute('aria-expanded', 'false'); };
    if (now) go(); else closeT = setTimeout(go, 180);
  }
  document.addEventListener('pointerover', (e) => {
    if (!fine) return;
    if (e.target.closest('[data-rz-mega], [data-rz-mega-panel]')) { clearTimeout(closeT); clearTimeout(openT); openT = setTimeout(open, 70); }
  });
  document.addEventListener('pointerout', (e) => {
    if (!fine || !html.classList.contains('rz-mega-open') && !openT) return;
    const from = e.target.closest('[data-rz-mega], [data-rz-mega-panel]');
    const to = e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('[data-rz-mega], [data-rz-mega-panel]');
    if (from && !to) close();
  });
  document.addEventListener('click', (e) => {
    if (e.target.closest('.rz-shop-btn')) { e.preventDefault(); html.classList.contains('rz-mega-open') ? close(true) : open(); return; }
    if (html.classList.contains('rz-mega-open') && !e.target.closest('[data-rz-mega-panel]')) close(true);
  });
  document.addEventListener('focusin', (e) => {
    if (e.target.closest('[data-rz-mega], [data-rz-mega-panel]')) open();
    else if (html.classList.contains('rz-mega-open')) close(true);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && html.classList.contains('rz-mega-open')) { close(true); const b = btn(); if (b) b.focus(); } });
  addEventListener('scroll', () => { if (html.classList.contains('rz-mega-open') && !fine) close(true); }, { passive: true });
})();
